import styled from 'styled-components';
import { Card } from 'ui-toolkit';

export const FilterCard = styled(Card)`
  min-width: 240px;
`;
